import {
  ApplicationFrameService,
  SrsSearchService,
  SidebarConfig,
  SidebarService,
  NavigationService,
  NotificationService,
  MultiActionSnackbarComponent,
  SnackbarActionConfig,
  RouterDataService,
} from "@edtell-common";
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-container",
  templateUrl: "./app-container.component.html",
  styleUrls: ["./app-container.component.scss"],
})
export class AppContainerComponent implements OnInit, OnDestroy {
  @ViewChild("header", { static: true }) headerElmRef: ElementRef;
  @ViewChild("footer", { static: true }) footerElmRef: ElementRef;

  notificationSub;
  sidebarConfig: SidebarConfig;
  headerComponent: Component;
  footerComponent: Component;

  constructor(
    private admiralSnackbar: MatSnackBar,
    private notificationService: NotificationService,
    private sidebarService: SidebarService,
    private applicationFrameService: ApplicationFrameService,
    private RouterDataService: RouterDataService,
    private srsSearchService: SrsSearchService,
  ) {
    this.notificationSub =
      this.notificationService.notificationEmitter.subscribe((config) => {
        this.openSnackbar(config);
      });

    this.sidebarService.sidebarState.subscribe((config) => {
      if (this.sidebarConfig != config) {
        this.sidebarConfig = null;
        setTimeout(() => {
          this.sidebarConfig = config;
        }, 10);
      }
    });
  }

  ngOnInit() {
    this.applicationFrameService.headerElement =
      this.headerElmRef.nativeElement;
  }

  openSnackbar(config: SnackbarActionConfig) {
    this.admiralSnackbar.openFromComponent(MultiActionSnackbarComponent, {
      data: config,
      duration: config.duration,
    });
  }

  ngOnDestroy(): void {
    this.notificationSub.unsubscribe();
  }

  get hasBreadcrumbs() {
    return this.RouterDataService.currentRouteHasBreadCrumbs();
  }
}
